import React from "react";
import { useLocation } from "react-router-dom";
import PageNotFound from "pages/PageNotFound";

const ALLOWED = new Set(["facebook.png", "instagram.png", "linkedin.png"]);

/**
 * When the server falls through to index.html for /assets/email/*.png (SPA fallback),
 * React Router would otherwise hit the * route.
 * Use exact Route paths in index.tsx (not :filename) — React Router v7 can fail to match dynamic
 * segments when the segment contains a dot (e.g. facebook.png).
 */
const PublicEmailAsset: React.FC = () => {
  const { pathname } = useLocation();
  const filename = pathname.split("/").filter(Boolean).pop() ?? "";
  if (!ALLOWED.has(filename)) {
    return <PageNotFound />;
  }
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  const src = `${base}/assets/email/${filename}`;

  return (
    <div
      style={{
        margin: 0,
        padding: "clamp(12px, 4vw, 24px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100vw",
        boxSizing: "border-box",
        background: "#fff",
        textAlign: "center",
        overflowX: "hidden",
      }}
    >
      <img
        src={src}
        alt=""
        style={{
          display: "block",
          maxWidth: "min(100%, 280px)",
          width: "auto",
          height: "auto",
          margin: "0 auto",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default PublicEmailAsset;
